import React, { useEffect } from 'react';
import { clientConfig } from '../config/clientConfig';

declare global {
  interface Window {
    Trustpilot?: any;
    trustpilotScriptLoaded?: boolean;
  }
}

export default function TrustpilotScript() {
  useEffect(() => {
    // Skip Trustpilot loading if disabled for this environment
    if (!clientConfig.isTrustpilotEnabled) {
      console.log('🚫 Trustpilot disabled for environment:', clientConfig.environmentName);
      return;
    }

    // Prevent multiple script loads
    if (window.trustpilotScriptLoaded) {
      return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    script.async = true;
    script.defer = true;
    
    script.onload = () => {
      window.trustpilotScriptLoaded = true;
      // Trigger any pending widget loads
      if (window.Trustpilot && window.Trustpilot.loadFromElement) {
        const widgets = document.querySelectorAll('.trustpilot-widget:not([data-tp-loaded])');
        widgets.forEach(widget => {
          widget.setAttribute('data-tp-loaded', 'true');
          window.Trustpilot.loadFromElement(widget);
        });
      }
    };

    script.onerror = () => {
      console.warn('Failed to load Trustpilot script');
    };
    
    document.head.appendChild(script);
    
    return () => {
      // Only remove if we added it
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);
  
  return null;
}